
export const emojis = [
	"🐵",
	"🐒",
	"🦍",
	"🦧",
	"🐶",
	"🐕",
	"🦮",
	"🐕‍🦺",
	"🐩",
	"🐺",
	"🦊",
	"🦝",
	"🐱",
	"🐈",
	"🐈‍⬛",
	"🦁",
	"🐯",
	"🐅",
	"🐆",
	"🐴",
	"🫎",
	"🫏",
	"🐎",
	"🦄",
	"🦓",
	"🦌",
	"🦬",
	"🐮",
	"🐂",
	"🐃",
	"🐄",
	"🐷",
	"🐖",
	"🐗",
	"🐽",
	"🐏",
	"🐑",
	"🐐",
	"🐪",
	"🐫",
	"🦙",
	"🦒",
	"🐘",
	"🦣",
	"🦏",
	"🦛",
	"🐭",
	"🐁",
	"🐀",
	"🐹",
	"🐰",
	"🐇",
	"🐿️",
	"🦫",
	"🦔",
	"🦇",
	"🐻",
	"🐻‍❄️",
	"🐨",
	"🐼",
	"🦥",
	"🦦",
	"🦨",
	"🦘",
	"🦡",
	"🐾",
	"🦃",
	"🐔",
	"🐓",
	"🐣",
	"🐤",
	"🐥",
	"🐦",
	"🐧",
	"🕊️",
	"🦅",
	"🦆",
	"🦢",
	"🦉",
	"🦤",
	"🪶",
	"🦩",
	"🦚",
	"🦜",
	"🪽",
	"🐦‍⬛",
	"🪿",
	"🐦‍🔥",
	"🐸",
	"🐊",
	"🐢",
	"🦎",
	"🐍",
	"🐲",
	"🐉",
	"🦕",
	"🦖",
	"🐳",
	"🐋",
	"🐬",
	"🫍",
	"🦭",
	"🐟",
	"🐠",
	"🐡",
	"🦈",
	"🐙",
	"🐚",
	"🪸",
	"🪼",
	"🦀",
	"🦞",
	"🦐",
	"🦑",
	"🦪",
	"🐌",
	"🦋",
	"🐛",
	"🐜",
	"🐝",
	"🪲",
	"🐞",
	"🦗",
	"🪳",
	"🕷️",
	"🕸️",
	"🦂",
	"🦟",
	"🪰",
	"🪱",
	"🦠",
	"😺",
	"😸",
	"😹",
	"😻",
	"😼",
	"😽",
	"🙀",
	"😿",
	"😾",
	"🙈",
	"🙉",
	"🙊",
	"😀",
	"😃",
	"😄",
	"😁",
	"😆",
	"😅",
	"🤣",
	"😂",
	"🙂",
	"🙃",
	"🫠",
	"😉",
	"😊",
	"😇",
	"🥰",
	"😍",
	"🤩",
	"😘",
	"😗",
	"☺️",
	"😚",
	"😙",
	"🥲",
	"😋",
	"😛",
	"😜",
	"🤪",
	"😝",
	"🤑",
	"🤗",
	"🤭",
	"🫢",
	"🫣",
	"🤫",
	"🤔",
	"🫡",
	"🤠",
	"🥳",
	"🥸",
	"😎",
	"🤓",
	"🧐",
	"💩",
	"🤡",
	"👹",
	"👺",
	"👻",
	"👽",
	"👾",
	"🤖",
	"🤐",
	"🤨",
	"😶‍🌫️",
	"😏",
	"😒",
	"🙄",
	"😬",
	"😮‍💨",
	"🤥",
	"🫨",
	"🙂‍↔️",
	"🙂‍↕️",
	"😷",
	"🤒",
	"🤕",
	"🤢",
	"🤮",
	"🤧",
	"🥵",
	"🥶",
	"🥴",
	"😵",
	"😵‍💫",
	"🤯",
	"😕",
	"🫤",
	"😟",
	"🙁",
	"☹️",
	"😮",
	"😯",
	"😲",
	"😳",
	"🫪",
	"🥺",
	"🥹",
	"😦",
	"😧",
	"😨",
	"😰",
	"😥",
	"😢",
	"😭",
	"😱",
	"😖",
	"😣",
	"😞",
	"😓",
	"😩",
	"😫",
	"🥱",
	"😤",
	"😡",
	"😠",
	"🤬",
	"😈",
	"👿",
	"💀",
	"☠️",
	"😌",
	"🤤",
	"😴",
	"🫩",
]

